import { render, staticRenderFns } from "./form-segnalazione-generica.vue?vue&type=template&id=8c7ca590&"
import script from "./form-segnalazione-generica.vue?vue&type=script&lang=js&"
export * from "./form-segnalazione-generica.vue?vue&type=script&lang=js&"
import style0 from "./form-segnalazione-generica.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports